import { FavoriteStatus } from '@app/data/clients/listsClient/types';
import {
  FavoriteMutation,
  FavoriteMutationVariables,
  GetFavoritedStatusesQueryVariables,
  UnfavoriteMutation,
} from '@app/data/lists';
import {
  LISTS_ARE_FAVORITED_PUBLIC_ENDPOINT,
  LISTS_FAVORITE_PUBLIC_ENDPOINT,
  LISTS_UNFAVORITE_PUBLIC_ENDPOINT,
} from '@app/pages/api/constants';
import logger from '@redbubble/next/logger';
import { getSafeUrl } from '@redbubble/utils/getSafeUrl';

export const getFavoriteStatuses = async (
  variables: GetFavoritedStatusesQueryVariables
) => {
  const url = getSafeUrl(
    LISTS_ARE_FAVORITED_PUBLIC_ENDPOINT,
    window.location.href
  );

  if (!url) {
    const err = new Error('get favorites statuses URL is not valid');
    logger.error(
      {
        err,
        message: err.message,
      },
      err.message
    );
    return;
  }

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(variables),
  }).then((res) => {
    if (!res.ok) {
      throw new Error('Failed to fetch favorite statuses from monolith-list');
    }
    return res;
  });

  const data: FavoriteStatus[] | undefined = await response.json();

  return data;
};

export const addToFavorite = async (variables: FavoriteMutationVariables) => {
  const url = getSafeUrl(LISTS_FAVORITE_PUBLIC_ENDPOINT, window.location.href);

  if (!url) {
    const err = new Error('add to favorites URL is not valid');
    logger.error(
      {
        err,
        message: err.message,
      },
      err.message
    );
    return;
  }

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(variables),
  }).then((res) => {
    if (!res.ok) {
      throw new Error('Failed to add work to favorites');
    }
    return res;
  });

  const data: FavoriteMutation['favorite'] = await response.json();

  return data;
};

export const removeFromFavorite = async (variables: any) => {
  const url = getSafeUrl(
    LISTS_UNFAVORITE_PUBLIC_ENDPOINT,
    window.location.href
  );

  if (!url) {
    const err = new Error('remove from favorites URL is not valid');
    logger.error(
      {
        err,
        message: err.message,
      },
      err.message
    );
    return;
  }

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(variables),
  }).then((res) => {
    if (!res.ok) {
      throw new Error('Failed to remove work from favorites');
    }
    return res;
  });

  const data: UnfavoriteMutation['unfavorite'] = await response.json();

  return data;
};

//this needs to also handle inventoryItems
export const favoriteStatus = (
  workId: number,
  favoriteStatuses: FavoriteStatus[]
): boolean => {
  const status = favoriteStatuses.find(({ item }) => {
    if (item.__typename === 'WorkFavorite') {
      return item.workId === workId.toString();
    }
  });

  if (!status) return false;

  return status.isFavorited;
};
